'use client';

import { c as _c } from "react/compiler-runtime";
import type { Subscription } from '@algoacademy/backend/modules/marketplace/enums';
import type { BasicMentoringProductDTO } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { ORDER_TYPE } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/types';
import { MentoringCard } from '../../_components/MentoringCard';
import { calculateBasicMentoringPrice } from '../../prices';
import { BasicMentoringOptions } from './Options';
export type { Subscription } from '@algoacademy/backend/modules/marketplace/enums';
export function getDefaultBasicProduct(subscription: Subscription): BasicMentoringProductDTO {
  return {
    order: ORDER_TYPE.BASIC_MENTORING,
    price: calculateBasicMentoringPrice(),
    subscription,
    email: '',
    name: 'Mentoring podstawowy',
    quantity: 1
  };
}

// type BasicMentoringProps = {
//   activeSubscriptionTab: Subscription
//   setActiveSubscriptionTab: Dispatch<SetStateAction<Subscription>>
// }

export function BasicMentoring() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MentoringCard title="Mentoring podstawowy" details={"Odpowiada on uniwersalnym potrzebom uczni\xF3w. Idealny dla tych, kt\xF3rzy rozpoczynaj\u0105 przygod\u0119 z mentoringiem.\nW ramach mentoringu otrzymujesz:"}><BasicMentoringOptions /></MentoringCard>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}